import SVGInjector from 'svg-injector';
export default {
  init() {
	$.extend($.easing,
		{
			def: 'easeOutQuad',
      easeInOutExpo: function (x, t, b, c, d) {
        if (t===0) { return b; }
        if (t===d) { return b+c; }
        if ((t/=d/2) < 1) { return c/2 * Math.pow(2, 10 * (t - 1)) + b; }
        return c/2 * (-Math.pow(2, -10 * --t) + 2) + b;
      },
    });
    var settings;
    var disableScrollFn = false;
    var navItems;
    var navs = {}, sections = {};

    function populateDestinations() {
      navItems.each(function(){
        var scrollID = $(this).attr('href').substring(1);
        navs[scrollID] = (settings.activateParentNode)? this.parentNode : this;
        sections[scrollID] = $(document.getElementById(scrollID)).offset().top;
      });
    }
    
    function activateNav(navID) {
      for (var nav in navs) { $(navs[nav]).removeClass('active'); }
      $(navs[navID]).addClass('active');
    }

    $.fn.navScroller = function(options) {
      settings = $.extend({
        scrollToOffset: 0,
        scrollSpeed: 800,
        activateParentNode: true,
      }, options );
      navItems = this;
      

      //attatch click listeners
      navItems.on('click', function(event){
        event.preventDefault();
          var navID = $(this).attr("href").substring(1);
          disableScrollFn = true;
          activateNav(navID);
          populateDestinations(); //recalculate these!
          $('html,body').animate({scrollTop: sections[navID] - settings.scrollToOffset},
            settings.scrollSpeed, "easeInOutExpo", function(){
              disableScrollFn = false;
            }
          );
      });

      //populate lookup of clicable elements and destination sections
      
      // if ( $('body').hasClass('home') ){
      populateDestinations();
      // } //should also be run on browser resize, btw

      // setup scroll listener
      $(document).scroll(function(){
        if (disableScrollFn) { return; }
        var page_height = $(window).height();
        var pos = $(this).scrollTop();
				for (var i in sections) {
          if ((pos + settings.scrollToOffset >= sections[i]) && sections[i] < pos + page_height){
            activateNav(i);
          }
        }
      });
    };
    // Hamburger menu
    $('#nav-toggle').click(function() {
      $(this).toggleClass('active');
      $('body').toggleClass('menu-open');
    });
    $('.page-link').click(function() {
      $('body').toggleClass('menu-open');      
      setTimeout(
        function()
        {
          $('#nav-toggle').toggleClass('active');
        }, 450);
    });

    // Inject SVGs
    var mySVGsToInject = document.querySelectorAll('img.svg-inject');
    SVGInjector(mySVGsToInject);
    
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js